import type { OutageEvent } from '../../../types/outage';

export function formatRelativeDuration(ms: number): string {
  if (ms < 60_000) return 'just now';
  const minutes = Math.floor(ms / 60_000);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  return `${days}d ago`;
}

export interface CurrentOutageTotals {
  customersOut: number;
  communities: number;
}

export interface StormSummary {
  startedAgo: string;
  nowOut: number;
  peakOut: number;
  communities: number;
}

export function buildStormSummary(
  event: OutageEvent,
  current: CurrentOutageTotals,
  now: Date,
): StormSummary {
  const startedMs = now.getTime() - new Date(event.startedAt).getTime();
  return {
    startedAgo: formatRelativeDuration(Math.max(0, startedMs)),
    nowOut: current.customersOut,
    peakOut: event.peakCustomersOut,
    communities: current.communities,
  };
}
